
import sendMessage from "./sendMessage";
import login from './login'

export {
  sendMessage,
  login
}




// WEBPACK FOOTER //
// ./src/services/chat/index.js